import React, { Dispatch, FC } from 'react';
import './index.scss';
import { ForgeScaffold } from '@tylertech/forge-react';
import Interval from './components/Interval';
import { FrequencyConfig } from 'common/types/frequencySelector/frequencySelector';
import Dates from './components/Dates';
import TimeDetails from './components/TimeDetails';
import { I18n } from 'common/i18n';
import classNames from 'classnames';

const scope = 'shared.components.frequency_selector';

export interface FrequencySelectorProps {
  value: FrequencyConfig;
  setValue: Dispatch<React.SetStateAction<FrequencyConfig>>;
  className?: string;
  isFrequencyTimeInvalid: boolean;
  isFrequencyStartDateInvalid: boolean;
  isFrequencyEndDateInvalid: boolean;
  isIntervalInvalid: boolean;
}

const FrequencySelector: FC<FrequencySelectorProps> = (props) => {
  const {
    className,
    value,
    setValue,
    isFrequencyTimeInvalid,
    isFrequencyStartDateInvalid,
    isFrequencyEndDateInvalid,
    isIntervalInvalid,
  } = props;

  return (
    <ForgeScaffold
      className={classNames('frequency-picker-container', className)}
      data-testid="frequency-selector"
    >
      <div slot="header">
        <p className="forge-typography--heading3">{I18n.t('title', { scope })}</p>
      </div>
      <div slot="body">
        <Interval value={value.intervalInfo} setValue={setValue} isIntervalInvalid={isIntervalInvalid} />
        <TimeDetails
          value={value.timeInfo}
          setValue={setValue}
          datesInfo={value.datesInfo}
          isFrequencyTimeInvalid={isFrequencyTimeInvalid}
        />
        <Dates
          value={value.datesInfo}
          setValue={setValue}
          timeZone={value.timeInfo.timeZone}
          isFrequencyStartDateInvalid={isFrequencyStartDateInvalid}
          isFrequencyEndDateInvalid={isFrequencyEndDateInvalid}
        />
      </div>
    </ForgeScaffold>
  );
};

export default FrequencySelector;
